(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bak"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, mega-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kg-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.link_list_heading').forEach((el) => {
      el.addEventListener('click', function () {
        var childMenu = el.nextElementSibling;
        var isDesktop = window.matchMedia('(min-width: 1025px)').matches;

        if (isDesktop) {
          var shouldOpen = !childMenu.classList.contains('open');
          document.querySelectorAll('.link_list_heading').forEach(function (heading) {
            heading.classList.toggle('open', shouldOpen);
          });
          document.querySelectorAll('.link_list_data .link_list').forEach(function (list) {
            list.classList.toggle('open', shouldOpen);
          });
          var footerContainer = el.closest('.footer');
          if (footerContainer) {
            footerContainer.classList.toggle('footer-links-open', shouldOpen);
          }
          return;
        }

        el.classList.toggle('open');
        childMenu.classList.toggle('open');
      });
    });

    const splideElement = document.querySelector('.as_seen_on_splide');
    const scrollbar = document.querySelector('.splide__scrollbar');
    const handle = document.querySelector('.splide__scrollbar__handle');

    if (!splideElement || !scrollbar || !handle || typeof Splide === 'undefined') {
      return;
    }

    var asseenon = new Splide('.as_seen_on_splide', {
      type: 'slide',
      snap: true,
      pagination: false,
      arrows: false,
      perPage: 4,
      perMove: 1,
      gap: '20px',
      breakpoints: {
        640: {
          perPage: 1.5,
          drag: 'free',
          type: 'loop',
        },
      },
    });

    let isDragging = false;
    let startX, startLeft;

    function updateScrollbar() {
      const totalSlides = asseenon.length;
      const visibleSlides = asseenon.options.perPage;
      const end = totalSlides - visibleSlides;
      const handleWidth = (visibleSlides / totalSlides) * 100;
      const rate = asseenon.index / end;
      const maxScrollableDistance = 100 - handleWidth;

      handle.style.width = `${handleWidth}%`;
      handle.style.left = `${Math.min(rate * maxScrollableDistance, maxScrollableDistance)}%`;
    }

    handle.addEventListener('mousedown', (event) => {
      isDragging = true;
      startX = event.clientX;
      startLeft = parseFloat(handle.style.left || '0');
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      const scrollbarWidth = scrollbar.offsetWidth;
      const handleWidth = handle.offsetWidth;
      const deltaX = event.clientX - startX;
      const maxScrollableDistance = scrollbarWidth - handleWidth;
      let newLeft = startLeft + (deltaX / scrollbarWidth) * 100;
      newLeft = Math.max(0, Math.min(newLeft, (maxScrollableDistance / scrollbarWidth) * 100));
      handle.style.left = `${newLeft}%`;
      const totalSlides = asseenon.length;
      const visibleSlides = asseenon.options.perPage;
      const end = totalSlides - visibleSlides;
      const newIndex = Math.round((newLeft / (100 - (visibleSlides / totalSlides) * 100)) * end);
      asseenon.go(newIndex);
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        document.body.style.userSelect = '';
        const totalSlides = asseenon.length;
        const visibleSlides = asseenon.options.perPage;
        const end = totalSlides - visibleSlides;
        const rate = asseenon.index / end;
        const handleWidth = (visibleSlides / totalSlides) * 100;
        const maxScrollableDistance = 100 - handleWidth;
        handle.style.left = `${Math.min(rate * maxScrollableDistance, maxScrollableDistance)}%`;
      }
    });

    asseenon.on('mounted move resize', updateScrollbar);
    asseenon.mount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kg-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isCarvelaDesktop =
        window.matchMedia('(min-width: 1025px)').matches &&
        (
          document.body.classList.contains('brand-carvela') ||
          document.documentElement.dataset.brand === 'carvela'
        );

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isCarvelaDesktop) {
          this.preventReveal = false;
          requestAnimationFrame(this.reveal.bind(this));
        } else if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function() {
    const mainMenuEl = document.querySelector('[data-main-menu]');
    if (mainMenuEl) {
      mainMenuEl.style.display = 'block';
    }

    const marketPopup = document.querySelector('.market-popup');
    const marketFlag = document.querySelector('[data-market-flag]');
    const marketSelect = document.querySelector('[data-market-country-select]');
    const languageWrapper = document.querySelector('.market-popup-language');
    const languageSelect = document.querySelector('[data-market-language-select]');
    const marketOkButton = document.querySelector('[data-market-country-ok]');
    const flagSuffix = marketPopup?.dataset.flagSuffix || 'flag';

    const updateFeaturedFlag = (option) => {
      if (!marketFlag || !option) return;

      const flag = option.dataset.flag;

      if (!flag) return;

      marketFlag.src = flag;
      marketFlag.alt = `${option.textContent.trim()} ${flagSuffix}`;
    };

     const updateLanguages = (option) => {
  if (!languageWrapper || !languageSelect || !option) return;

  languageSelect.innerHTML = '';

  let languages = [];
try {
  languages = JSON.parse(option.dataset.languages || '[]');

  if (!Array.isArray(languages)) {
    languages = [];
  }
} catch (e) {
  languages = [];
}

 if (languages.length === 0) {
  languageWrapper.style.display = 'none';
  return;
}

languageWrapper.style.display = 'flex';

  languages.forEach((language) => {
    const opt = document.createElement('option');
    // Normalize language URL to a path-only value to avoid cross-domain redirects
    let langUrl = String(language.url || '').trim();
    // Strip origin if present (e.g. https://www.kurtgeiger.mx/fr -> /fr)
    langUrl = langUrl.replace(/^https?:\/\/[^^\/]+/i, '').replace(/^https?:\/\//i, '');
    // If after stripping we don't have a leading slash, add one
    if (!langUrl.startsWith('/')) langUrl = '/' + langUrl;
    // Normalize slashes and remove trailing slash (keep root as '/')
    langUrl = langUrl.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
    opt.value = langUrl;
    opt.textContent = language.name;
    languageSelect.appendChild(opt);
  });
  // Default the language select to the current page locale if available,
  // otherwise fallback to the first language option.
  try {
    const currentPathname = window.location.pathname || '/';
    const currentLocaleMatch = currentPathname.match(/^\/([a-z]{2})(?=\/|$)/i);
    let desiredValue = null;
    if (currentLocaleMatch) {
      const locale = currentLocaleMatch[1].toLowerCase();
      for (let i = 0; i < languageSelect.options.length; i++) {
        const o = languageSelect.options[i];
        if (!o || !o.value) continue;
        const val = o.value.toLowerCase();
        // match '/fr' or absolute URL with pathname starting with '/fr'
        if (val.startsWith('/' + locale) || val.includes('/' + locale + '/')) {
          desiredValue = o.value;
          break;
        }
        try {
          const parsed = new URL(o.value, window.location.origin);
          if (parsed.pathname.toLowerCase().startsWith('/' + locale)) {
            desiredValue = o.value;
            break;
          }
        } catch (e) {
          // ignore
        }
      }
    }
    if (!desiredValue && languageSelect.options.length > 0) desiredValue = languageSelect.options[0].value;
    if (desiredValue) languageSelect.value = desiredValue;
  } catch (e) {
    // ignore any unexpected errors
  }
};

if (marketSelect) {
  const selectedOption = marketSelect.selectedOptions?.[0];

  updateFeaturedFlag(selectedOption);
  updateLanguages(selectedOption);

  marketSelect.addEventListener('change', () => {
    const option = marketSelect.selectedOptions?.[0];

    updateFeaturedFlag(option);
    updateLanguages(option);
  });
}
  
   if (marketOkButton) {
  marketOkButton.addEventListener('click', () => {
    const selectedLanguage = languageSelect?.value;

    // If a language entry exists, try to preserve the current path and just
    // prefix it with the selected locale (e.g. /fr/collections/...). If the
    // language value already contains a full path, navigate to it directly.
    if (selectedLanguage) {
      const origin = window.location.origin;
      const search = window.location.search || '';
      const hash = window.location.hash || '';

      // Normalize selectedLanguage
      let sel = String(selectedLanguage || '').trim();
      if (!sel) return;

      // If the provided value looks like an absolute URL, parse it. If it points
      // to a different host (another market), prefer staying on the current
      // origin and only apply the locale path. This prevents accidental
      // redirecting the user to a different store domain.
      if (/^https?:\/\//i.test(sel)) {
        try {
          const parsed = new URL(sel);
          // If same host, navigate directly
          if (parsed.host === window.location.host) {
            window.location.href = sel;
            return;
          }

          // Different host: attempt to extract locale prefix from the path
          const path = parsed.pathname || '/';
          const localeMatch = path.match(/^\/([a-z]{2})(?=\/|$)/i);
          const localePrefix = localeMatch ? '/' + localeMatch[1] : '';
          const rest = path.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/';
          let newPath = (localePrefix + rest).replace(/\/+/g, '/');
          newPath = newPath.replace(/\/$/, '') || '/';
          window.location.href = window.location.origin + newPath + search + hash;
          return;
        } catch (err) {
          // If parsing fails, fall back to navigating to sel
          window.location.href = sel;
          return;
        }
      }

      // Ensure it starts with a single leading slash
      if (!sel.startsWith('/')) sel = '/' + sel;
      sel = sel.replace(/\/+/g, '/').replace(/\/$/, '');

      // If the selected language contains more than just the locale segment
      // (e.g. '/fr/collections/something'), treat it as a full path.
      const selSegments = sel.split('/').filter(Boolean);
      if (selSegments.length > 1) {
        window.location.href = origin + sel + search + hash;
        return;
      }

      // Otherwise sel is a locale prefix like '/fr'. Strip an existing two-letter
      // locale prefix from the current path (if present) then prefix with sel.
      let currentPath = window.location.pathname || '/';
      // Remove leading locale segment like '/fr' or '/en' if present
      const strippedPath = currentPath.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/';

      // Build new path ensuring single slashes
      let newPath = (sel + '/' + strippedPath).replace(/\/+/g, '/');
      // If result ends with duplicate trailing slash, normalize
      newPath = newPath.replace(/\/$/, '') || '/';

      window.location.href = origin + newPath + search + hash;
      return;
    }

    const selectedOption = marketSelect?.selectedOptions?.[0];
    const redirectBase = selectedOption?.dataset.redirectBase;

    if (!redirectBase) return;

    window.location.href = redirectBase;
  });
}

    let headerElement = document.querySelector('header');
    let headerWrapperElement = document.querySelector('.header-wrapper');
    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    const isCarvelaBrand =
      document.documentElement.dataset.isCarvelaBrand === 'true' ||
      document.documentElement.dataset.brand === 'carvela' ||
      /carvela/i.test(window.location.hostname);
    const hoverLogoUrl = 'https://kurtgeiger-carvela-au.myshopify.com/cdn/shop/files/padding_test_brown.png?v=1788447508&width=240';

    const desktopLogoImgs = Array.from(
      document.querySelectorAll('.section-header .desktop .header__logo-link img')
    );

    function setHoverLogoState(enabled) {
      if (!isDesktop || !isCarvelaBrand || desktopLogoImgs.length === 0) return;

      desktopLogoImgs.forEach((img) => {
        if (!img.dataset.originalSrc) {
          img.dataset.originalSrc = img.getAttribute('src') || '';
        }
        if (!img.dataset.originalSrcset) {
          img.dataset.originalSrcset = img.getAttribute('srcset') || '';
        }

        if (enabled) {
          img.setAttribute('src', hoverLogoUrl);
          img.removeAttribute('srcset');
        } else {
          if (img.dataset.originalSrc) {
            img.setAttribute('src', img.dataset.originalSrc);
          }
          if (img.dataset.originalSrcset) {
            img.setAttribute('srcset', img.dataset.originalSrcset);
          }
        }
      });
    }

    if (mainMenuEl && headerElement) {
      mainMenuEl.addEventListener('mouseenter', function() {
        headerElement.classList.add('hover-happen')
          headerWrapperElement?.classList.add('hover-happen')
          setHoverLogoState(true)
      })

      mainMenuEl.addEventListener('mouseleave', function() {
        headerElement.classList.remove('hover-happen')
          headerWrapperElement?.classList.remove('hover-happen')
          setHoverLogoState(false)
      })
    }

    document.querySelectorAll('.has-child').forEach((el) => {
        el.addEventListener('click', function(){
            var childMenu = el.nextElementSibling;
            childMenu.classList.add('open')
        })
    })

    const resetBtn = document.querySelector('.reset__button');
    if (resetBtn) {
      resetBtn.addEventListener('click', function(){
        document.querySelector('.header-search').classList.remove('open');
        document.querySelector('body').classList.remove('overflow-hidden-true');
        document.querySelector('html').click();
      })
    }

    document.querySelector('.header-search__overlay').addEventListener('click', function(){
        document.querySelector('.header-search').classList.remove('open');
        document.querySelector('body').classList.remove('overflow-hidden-true');
        document.querySelector('html').click();
    })

    document.querySelectorAll('.header__icon--search').forEach((el) => {
        el.addEventListener('click', function(event){
            event.preventDefault();
            document.querySelector('.header-search').classList.toggle('open');
            document.querySelector('body').classList.toggle('overflow-hidden-true');
            const searchInput = document.querySelector('.fast-autocomplete-input');
            setTimeout(() => {
              searchInput?.focus();
            }, 100);
        })
    })

    document.querySelectorAll('.child_menu__arrow').forEach((el) => {
        el.addEventListener('click', function(){
            var parentMenu = el.parentElement;
            parentMenu.classList.remove('open')
        })
    })

    document.querySelectorAll('.market-popup-close').forEach((el) => {
        el.addEventListener('click', function(){
        marketPopup?.classList.remove('open')
            document.querySelector('body').classList.remove('overflow-hidden-true');
        })
    })

    document.querySelectorAll('.country-flag').forEach((el) => {
        el.addEventListener('click', function(){
        marketPopup?.classList.add('open')
            document.querySelector('body').classList.add('overflow-hidden-true');
        })
    })

    document.querySelectorAll('.market-popup-overlay').forEach((el) => {
        el.addEventListener('click', function(){
        marketPopup?.classList.remove('open')
            document.querySelector('body').classList.remove('overflow-hidden-true');
        })
    })

    // Cart icon redirect to cart page
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      cartIconBubble.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = this.href;
      });
    }

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sus-product-tabs"]) return;
  try {
    
    $(document).ready(function () {	
      $('ul.inno_tabs li').click(function () {
          var tab_id = $(this).attr('data-tab');
          $('ul.inno_tabs li').removeClass('current');
          $('.inno_tab_contant').removeClass('current');
          $(this).addClass('current');
          $("#" + tab_id).addClass('current');
      }); 
    });
  
  } catch(e) { console.error(e); }
})();
})();
